import styled from "styled-components";
import {
  // BsChevronDown,
  // BsChevronUp,
  // BsChevronRight,
  BsDownload,
} from "react-icons/bs";

import {
  HiOutlineChevronRight,
  HiOutlineChevronDown,
  HiOutlineChevronUp,
} from "react-icons/hi";

export const Button = styled.div`
  font-weight: 700;
  font-size: 1.4rem;
  border: 1px solid #999;
  background: ${(props) => props.theme.colors.white};
  padding: 0.5rem 2rem;
  // display: inline-block;
  border-radius: 99px;
  cursor: pointer;
  display: flex;
  align-items: center;
  line-height: 1.25;

  &:hover {
    border-color: ${(props) => props.theme.colors.red};
    color: ${(props) => props.theme.colors.red};
  }
`;

export const ButtonIconContainer = styled.span`
  display: block;
  margin-right: 0.5rem;
`;

export const ButtonIconContainerSuffix = styled.span`
  margin-left: 0.5rem;
  display: block;
`;

export const ButtonDownIcon = styled(HiOutlineChevronDown)`
  display: block;
`;

export const ButtonUpIcon = styled(HiOutlineChevronUp)`
  display: block;
`;

export const ButtonDownloadIcon = styled(BsDownload)`
  display: block;
`;

export const ButtonRightIcon = styled(HiOutlineChevronRight)`
  display: block;
`;
